import React from 'react';
import { ShieldCheck } from 'lucide-react';
import './PrivacySection.css';

function PrivacySection({ label, children }) {
  return (
    <div className="privacy-section">
      <div className="privacy-section__header">
        <ShieldCheck size={13} className="privacy-section__icon" />
        <span className="privacy-section__label">{label}</span>
      </div>
      <div className="privacy-section__body">
        {children}
      </div>
    </div>
  );
}

export default PrivacySection;
